import { cn } from '@/lib/utils';
import { BillTotalsVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import ParticipantTotalsSummary from './ParticipantTotalsSummary';
import ParticipantShareRow from './ParticipantShareRow';
import { getShare } from './participantTotals';

interface ParticipantBillFooterProps
  extends React.HTMLAttributes<HTMLDivElement> {
  totals: BillTotalsVm;
  isEditing: boolean;
  bookingCode: string;
  onOpenInstallments: () => void;
  showShare?: boolean;
}

/**
 * Stopka ekranu uczestnika — szare zamknięcie listy sekcji: kwoty rozliczenia
 * i odsyłacz do rezerwacji.
 */
const ParticipantBillFooter = ({
  totals,
  isEditing,
  bookingCode,
  onOpenInstallments,
  showShare = true,
  className,
  ...props
}: ParticipantBillFooterProps) => (
  <div
    className={cn(
      'border-t border-neutral-100 bg-neutral-50 pb-1 pt-[18px]',
      className,
    )}
    {...props}
  >
    <ParticipantTotalsSummary
      className="mx-4 sm:mx-7"
      totals={totals}
      isEditing={isEditing}
    />

    {showShare && (
      <ParticipantShareRow
        className="mt-4 border-t border-neutral-200 px-4 py-3.5 sm:px-7"
        share={getShare(totals, isEditing)}
        bookingCode={bookingCode}
        onOpenInstallments={onOpenInstallments}
      />
    )}
  </div>
);

export default ParticipantBillFooter;
